export const Home = () => {
  return (
    <div id='home' className='header'>
      <div className='row h-100 d-flex justify-content-center align-items-center' >
        <div className='col-12' style={{ width: "fit-content" }}>
          <div className='headerText'>
            <div className='hello'>Hello, I'm</div>
            <div>
              <div className='box'>
                <div className='title'>
                  <span className='block'></span>
                  <h1>
                    Ahmed Arafa <span></span>
                  </h1>
                </div>

                <div className='role'>
                  <div className='block'></div>
                  <p>Web Developer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
